export const ETA_PREPARATION_MARGIN = 10;

export const DEFAULT_LOCALE = "en";
export const DEFAULT_CURRENCY = "USD";
export const DELIVERECT_TERMS_AND_CONDITION =
  "https://www.deliverect.com/en/social-media-ordering-terms-and-conditions";
export const DELIVERECT_PRIVACY_POLICY =
  "https://www.deliverect.com/en/social-media-ordering-privacy-notice";
